import { useMemo } from 'react';

import useMediaQuery from '@mui/material/useMediaQuery';

import type { FenrirThemeMode, PaletteMode } from '../theme-mode';

export const useDefaultThemeMode = (
  initialMode?: FenrirThemeMode,
): PaletteMode => {
  const prefersLightMode = useMediaQuery('(prefers-color-scheme: light)');

  // The default mode when the storage is empty (user's first visit).
  const defaultMode = useMemo(() => {
    if (initialMode) {
      // TODO: update initialMode to be only 'light' | 'dark' and default to preferred color scheme
      if (initialMode === 'system')
        return prefersLightMode === true ? 'light' : 'dark';

      return initialMode;
    }

    return prefersLightMode === true ? 'light' : 'dark';
  }, [initialMode, prefersLightMode]);

  return defaultMode;
};
